module.exports = __webpack_public_path__ + "static/media/de.30bf2384.png";